// Perspective constants
export const HORIZON_Y = 120;
export const GROUND_Y = 380;
export const CENTER_X = 250;

// Track constants
export const TRACK_WIDTH_AT_HORIZON = 83;
export const TRACK_HALF_WIDTH = TRACK_WIDTH_AT_HORIZON / 2;
export const TRACK_EDGE = 20;

// Spawning distances (in meters)
export const OBSTACLE_SPACING_METERS = 5;
export const DECOR_SPACING_METERS = 2;
export const LINE_SPACING_METERS = 5;

// Game rules
export const RACE_DISTANCE = 1500;

export function getScale(y: number): number {
    const progress = (y - HORIZON_Y) / (GROUND_Y - HORIZON_Y);
    return 0.15 + Math.max(0, progress) * 0.85;
}

export function getSpeedMultiplier(scale: number): number {
    return Math.pow(scale + 0.1, 2) * 3;
}

export function getSpreadFactor(scale: number): number {
    return 1 + (scale - 0.15) * 5.9;
}
